"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateArrearsSubmissionFrontendForm = exports.arrearsFilesFrontendSchema = exports.arrearsSubmissionFrontendSchema = void 0;
// Arrears Form - Front End Schema Validator
var schema_validator_1 = require("@hobt/schema-validator");
var arrears_file_1 = require("../arrears-file");
var submission_1 = require("../submission");
var constants_1 = require("../constants");
exports.arrearsSubmissionFrontendSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['submission'],
    properties: {
        submission: submission_1.submissionSchema,
    },
};
exports.arrearsFilesFrontendSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['arrearsFiles'],
    properties: {
        arrearsFiles: {
            type: 'array',
            items: arrears_file_1.arrearsFileSchema,
            minItems: 1,
            maxItems: constants_1.maxFileUploadCount,
            errorMessage: "Should have a maximum of " + constants_1.maxFileUploadCount + " files",
        },
    },
};
exports.validateArrearsSubmissionFrontendForm = function (arrearsForm) {
    var arrearsFormValidator = new schema_validator_1.SchemaValidator(exports.arrearsSubmissionFrontendSchema, true, false, true, true);
    arrearsFormValidator.extendSchema(exports.arrearsFilesFrontendSchema);
    return arrearsFormValidator.validate(arrearsForm);
};
